import { FolkCameraAttribute } from '../folk-camera-attribute';
FolkCameraAttribute.define();
export { FolkCameraAttribute };
//# sourceMappingURL=folk-camera-attribute.js.map